import React from 'react';
import { Box } from '@mui/material';

/**
 * ICT OPS Logo — Uses the branded logo image.
 * Props:
 *   size — 'sm' | 'md' | 'lg' | 'xl'  (default 'md')
 */
export default function Logo({ size = 'md' }) {
  const heights = { sm: 40, md: 52, lg: 72, xl: 100 };
  const logoHeight = heights[size] || heights.md;

  return (
    <Box
      component="img"
      src="/ictopslogo.png"
      alt="ICT Ops"
      loading="eager"
      decoding="async"
      sx={{
        height: logoHeight,
        width: 'auto',
        objectFit: 'contain',
        display: 'block',
      }}
    />
  );
}
